import { gsap } from "../../_Global/js/global";

document.addEventListener('DOMContentLoaded', () => {
    const globalSearch = document.querySelector('.globalSearch');
    const closeButtons = document.querySelectorAll('.globalSearchClose');

    if(globalSearch) {
	    closeButtons.forEach(button => {
	        button.addEventListener('click', () => {  
	        	document.querySelector('html').classList.remove('no-scroll'); 

		        gsap.to(globalSearch, {
		            opacity: 0,
		            duration: 0.5,
		            onComplete: () => {
		                globalSearch.classList.remove('active');
		            }
		        });
		    });
	    });

	    document.addEventListener("keydown", (event) => {
	        if (event.key === "Escape") {
	            if (globalSearch.classList.contains('active')) {
		        	document.querySelector('html').classList.remove('no-scroll'); 

			        gsap.to(globalSearch, {
			            opacity: 0,
			            duration: 0.5,
			            onComplete: () => {
			                globalSearch.classList.remove('active');
			            }
			        });
	            }
	        }
	    });
    }
});
